
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import NewsHero from './components/NewsHero';
import NewsGrid from './components/NewsGrid';

export default function NewsPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <NewsHero />
        <NewsGrid />
      </main>
      <Footer />
    </div>
  );
}

const newsData = [
  {
    id: 1,
    title: '新シングル「あの雲のむこうがわ、その先に」ライブにて初演！',
    excerpt: 'とある映画（高校生が主人公の青春群像劇）の挿入歌オーディションがきっかけで生まれたこの曲。久下暁雅の方向性を決定づけた大切なシングル曲第１弾です。',
    content: 'とある映画（高校生が主人公の青春群像劇）の挿入歌オーディションがきっかけで生まれたこの曲。久下暁雅の方向性を決定づけた大切なシングル曲第１弾です。',
    date: '2026-02-21',
    category: 'リリース',
    image: 'https://readdy.ai/api/search-image?query=Professional%20recording%20studio%20session%20with%20musician%20holding%20acoustic%20guitar%20in%20intimate%20lighting%2C%20dark%20moody%20atmosphere%20with%20warm%20backlighting%20creating%20silhouettes%2C%20vintage%201970s%20aesthetic%20with%20psychedelic%20color%20tones%2C%20close-up%20composition%20focusing%20on%20upper%20body%20and%20guitar%2C%20artistic%20music%20photography%20with%20dramatic%20shadows%20and%20highlights&width=800&height=400&seq=news1&orientation=landscape',
    tags: ['新曲', 'リリース', 'あの雲のむこうがわ、その先に', '映画音楽']
  }
];
